import Vue from 'vue'
import Store from 'store'

import DemoComponent from './DemoComponent.vue'

const el = '.nti-component--demo-component'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                DemoComponent
            },
            template: '<DemoComponent />'
        })
    }
}

export default {
    render
}